import React, { useEffect, useState } from "react";
import "./index.scss";
import CloseIcon from "react-icons/lib/md/close";
import Resources from "./Resources";

import SkillContent from "../ToolTip/SkillContent";
import { domainInfo } from "../../util/domainInfo";
import SRS from "../../../../services/StudentRecordService";
import { useTranslation } from "react-i18next";
import { filterResourceForReports } from "../../util/filterResourceForReports";

export default function SkillModal(props) {
  const { data } = props;

  const [expanded, setExpanded] = useState(false);
  const [resources, setResources] = useState(null);

  const {t} = useTranslation("skills_status_report");

  useEffect(() => {
    if (!data) return;
    getData(data.skillId, data.studentId);
  }, [data]);

  async function getData(skillId, studentId) {
    const res = await SRS.getResources(skillId, studentId);
    const filteredResources = filterResourceForReports(res.skillResources.resources);
    setResources(filteredResources.resources || []);
  }

  if (!data) return null;

  if (props.isReadingRope) return <ReadingRopeResources />;

  const { skillName, skillArea } = data;
  const abbreviation = domainInfo[data.domain].abbr;

  return (
    <div onClick={onClose} className="skillmodal-backdrop">
      <div onClick={(e) => e.stopPropagation()} className="skillmodal-card">
        <div>
          <div className="skillmodal-skillname">
            <div className="skillmodal-abbrev">{abbreviation}</div>
            <div>{skillName}</div>
          </div>
          <div className="skillmodal-skillarea">{skillArea}</div>
          <SkillContent data={data} />
        </div>
        <ResourcesModal />
      </div>
    </div>
  );

  function onClose() {
    props.onClose();
    setResources(null);
    setExpanded(false);
  }

  function ReadingRopeResources() {
    return (
      <div onClick={onClose} className="skillmodal-backdrop">
        <div
          onClick={(e) => e.stopPropagation()}
          className="skillmodal-card-rr"
        >
          <ResourcesModal />
        </div>
      </div>
    );
  }

  function ResourcesModal() {
    return (
      <div>
        <CloseIcon className="skillmodal-xicon" onClick={onClose} />
        <div className="skillmodal-header">{t("Resources")}</div>
        <Resources
          resources={resources}
          expanded={expanded}
          setExpanded={setExpanded}
        />
      </div>
    );
  }
}
